<template>
  <div class="file-list" :style="`grid-template-columns: repeat(${columns}, 1fr)!important;`">
    <div class="file-item" v-for="(file, fileIndex) in fileListArray" :key="'awdawdwa'+fileIndex">
      <el-image v-if="file.url.endsWith('.png') || file.url.endsWith('.jpg')" style="width: 64px; height: 64px" :src=" imageUrlprefix + file.url" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2" :preview-src-list="[ imageUrlprefix + file.url]" show-progress  fit="cover" />
      <a :href=" imageUrlprefix + file.url" target="_blank" v-else>
        <el-image :src="imageUrlprefix + '/photo/generalFile.png'" style="width: 64px; height: 64px" />
      </a>
      <div class="file-item-name">
        <el-popover
            :content="file.fileName"
        >
          <template #reference>
            <el-text :truncated="true" style="padding: 0 2px">{{file.fileName}}</el-text>
          </template>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileList: {
      type: [String, Array],
      default: ""
    },
    columns: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      fileListArray: []
    }
  },
  watch: {
    fileList: {
      handler(newVal) {
        console.log(newVal, 'newVal');
        this.parseFileList();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    parseFileList() {
      if (!this.fileList) {
        this.fileListArray = [];
        return;
      }
      
      if (Array.isArray(this.fileList)) {
        // 如果直接传入数组
        this.fileListArray = this.fileList;
      } else if (typeof this.fileList === 'string') {
        // 如果是逗号分隔的字符串
        const urls = this.fileList.split(',').filter(url => url.trim());
        this.fileListArray = urls.map(url => {
          // 从url中提取文件名
          const fullPath = url.trim();
          const fileName = fullPath.split('/').pop() || fullPath;
          
          return {
            url: fullPath,
            fileName: fileName
          };
        });
      }
    }
  }
}

</script>

<style scoped lang="scss">



.file-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 350px;
  gap: 6px;


  .file-item {
    width: 64px;

    .file-item-name {
      margin-top: 4px;
      color: rgba(42, 51, 71, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 400;
      font-size: 12px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>